// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  title: '',
  description: '',
  mainImage: '',
  imagesWithDescription: [],
};

const packGuidelinesReducer = createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [types.PG_REQUEST_PAGE_DATA](state, action) {
    return {
      ...state,
    };
  },
  [types.PG_REQUEST_PAGE_DATA_SUCCESS](state, action) {
    return {
      ...state,
      ...action.data,
    };
  },
});

export default packGuidelinesReducer;
